import {
  ANSWER_CHANGE, ANSWER_CHANGE_DEVICE_INSTANTIATE,
  ANSWER_QUANTITY_CHANGE,
  DEVICE_ANSWER_CHANGE,
  DEVICE_INPUT_ANSWER_CHANGE,
} from './constants';

export function answerChange({ question, value }) {
  return {
    type: ANSWER_CHANGE,
    question,
    value,
  };
}

/**
 * We want to fire the update_item api programmatically for 'device' in EV.
 * @param question
 * @param value
 * @returns {{question, type: string, value}}
 */
export function answerChangeDeviceInstantiation({ question }) {
  return {
    type: ANSWER_CHANGE_DEVICE_INSTANTIATE,
    question,
  };
}

export function answerQuantityChange({ question, id, quantity }) {
  return {
    type: ANSWER_QUANTITY_CHANGE,
    question,
    id,
    quantity,
  };
}

export function deviceAnswerChange({ questionType, question, makeValue, modelValue }) {
  return {
    type: DEVICE_ANSWER_CHANGE,
    questionType,
    question,
    makeValue,
    modelValue,
  };
}

export function deviceInputAnswerChange({
  questionType,
  question,
  makeInputValue,
  modelInputValue,
}) {
  return {
    type: DEVICE_INPUT_ANSWER_CHANGE,
    questionType,
    question,
    makeInputValue,
    modelInputValue,
  };
}
